import theme, { appTheme } from '@/config/theme';

export { appTheme };
export default theme.colors;
